import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import {
  dismissAppLaunchSplash,
  isStandaloneDisplay,
  PWA_STANDALONE_START_PATH,
} from '@/lib/pwa/app-launch';

import { LandingPage } from './LandingPage';

/**
 * Marketing homepage for normal browser visitors. Installed PWAs must never
 * paint this route while auth is still resolving — they open the trip start
 * URL instead (see index.html + manifest start_url).
 */
export function LandingPageRoute() {
  const standalone = isStandaloneDisplay();

  useEffect(() => {
    if (!standalone) dismissAppLaunchSplash();
  }, [standalone]);

  if (standalone) {
    return <Navigate to={PWA_STANDALONE_START_PATH} replace />;
  }

  return <LandingPage />;
}
